import { DEVICE_TYPE_LABELS_UK, type DeviceType } from '@ukrop-nm/shared';
import type { DragEvent } from 'react';
import { DeviceIcon } from './DeviceIcon';
import { useIconPack } from '../icons/IconPackContext';

const PALETTE: DeviceType[] = [
  'switch',
  'router',
  'wifi_router',
  'access_point',
  'firewall',
  'server',
  'desktop',
  'laptop',
  'tablet',
  'display',
  'ip_phone',
  'wifi_phone',
  'printer',
  'camera',
  'nas',
  'modem',
  'lte_antenna',
  'satellite',
  'cloud',
  'iot',
  'ups',
  'power_station',
  'controller',
  'zone',
  'generic',
];

export function Palette({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { pack } = useIconPack();

  if (!open) return null;

  const beginDrag = (type: DeviceType, e: DragEvent) => {
    e.dataTransfer.setData('application/ukrop-device', type);
    e.dataTransfer.setData('text/plain', type);
    e.dataTransfer.effectAllowed = 'copy';
    // Backdrop otherwise covers the canvas and eats the drop
    document.body.classList.add('ukrop-palette-dragging');
  };

  const endDrag = () => {
    document.body.classList.remove('ukrop-palette-dragging');
  };

  return (
    <>
      <button
        type="button"
        className="palette-backdrop"
        aria-label="Закрити палітру"
        onClick={onClose}
        onDragOver={(e) => {
          e.preventDefault();
          e.dataTransfer.dropEffect = 'copy';
        }}
        onDrop={(e) => {
          e.preventDefault();
          endDrag();
          const type = (e.dataTransfer.getData('application/ukrop-device') ||
            e.dataTransfer.getData('text/plain')) as DeviceType;
          if (!type) return;
          window.dispatchEvent(
            new CustomEvent('ukrop-drop-device', {
              detail: { type, clientX: e.clientX, clientY: e.clientY },
            }),
          );
          onClose();
        }}
      />
      <aside className="palette palette-drawer">
        <div className="mb-3 flex items-center justify-between gap-2">
          <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">Палітра</h3>
          <button type="button" className="btn-sm" onClick={onClose}>
            ✕
          </button>
        </div>
        <p className="mb-3 text-theme-xs text-gray-500">
          Перетягніть на полотно або клацніть, щоб додати.
        </p>
        {PALETTE.map((type) => (
          <button
            key={type}
            type="button"
            className="palette-item"
            draggable
            onDragStart={(e) => beginDrag(type, e)}
            onDragEnd={endDrag}
            onClick={() => {
              window.dispatchEvent(
                new CustomEvent('ukrop-add-device', {
                  detail: {
                    type,
                    position: { x: 120 + Math.random() * 80, y: 100 + Math.random() * 80 },
                  },
                }),
              );
              onClose();
            }}
          >
            <span className="text-brand-500">
              <DeviceIcon type={type} pack={pack} size={22} />
            </span>
            <span>{DEVICE_TYPE_LABELS_UK[type]}</span>
          </button>
        ))}
      </aside>
    </>
  );
}
